import { Monitor, Moon, Sun } from 'lucide-react';
import { SegmentedControl, type SegmentedOption } from '@/components/ui/segmented-control';
import { useTheme, type ThemeChoice } from '@/lib/theme';

const OPTIONS: ReadonlyArray<SegmentedOption<ThemeChoice>> = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
];

/**
 * Light / Dark / System on the original-style segmented control (the 3-way choice is kept).
 * `iconOnly` (sidebar/drawer footer, UAT-1) shows just Sun / Moon / Monitor; each radio keeps
 * "Light" / "Dark" / "System" as its accessible name and tooltip.
 */
export function ThemeToggle({ fullWidth, iconOnly, className }: { fullWidth?: boolean; iconOnly?: boolean; className?: string }): JSX.Element {
  const { theme, setTheme } = useTheme();
  return (
    <SegmentedControl
      aria-label="Theme"
      value={theme}
      onChange={setTheme}
      options={OPTIONS}
      fullWidth={fullWidth}
      iconOnly={iconOnly}
      className={className}
    />
  );
}
